import { Sparkles } from 'lucide-react'
import type { FeatureWebModule } from '../../modules/core/index.js'
import { AdminClientBriefingsLine } from './components/AdminClientBriefingsLine.js'
import { AiUsagePage } from './components/AiUsagePage.js'
import { BriefingButton, InsightsBriefingButton } from './components/BriefingButton.js'
import { BRIEFINGS_HELP_TOPICS } from './help.js'
import { AI_USAGE_PATH, FEATURE_KEY, FEATURE_NAME } from './labels.js'

/**
 * The AI Briefings add-on's screens (docs/plans/ai-briefings-plan.md section
 * 13): the sparkle in the operator shell's header, which opens the briefing
 * dialog for the facility open or across facilities; the AI summary button in
 * the Insights page's own toolbar for this month, quarter or year of its
 * reports; System › AI for the admin; a usage line on the admin's client
 * detail; and the settings the admin may set for a client on the license,
 * each tightening the deployment's default. The defaults named here are the
 * deployment's own parameters' defaults, shown as placeholders.
 */
export const aiBriefingsWebModule: FeatureWebModule = {
  key: FEATURE_KEY,
  name: FEATURE_NAME,
  headerAction: BriefingButton,
  pageActions: [{ page: 'insights', action: InsightsBriefingButton }],
  adminPages: [{ path: AI_USAGE_PATH, label: 'AI', title: 'AI briefings usage', icon: Sparkles, group: 'system', page: ({ api }) => <AiUsagePage client={api.client} /> }],
  adminClientSection: { heading: 'AI Briefings', section: AdminClientBriefingsLine },
  licenseSettings: [
    { key: 'cooldownMinutes', label: 'Minutes between briefings', kind: 'number', defaultHint: '10' },
    { key: 'personDailyBriefings', label: 'Briefings a person a day', kind: 'number', defaultHint: '12' },
    { key: 'personDailyQuestions', label: 'Questions a person a day', kind: 'number', defaultHint: '30' },
    { key: 'personDailyEmails', label: 'Emails a person a day', kind: 'number', defaultHint: '12' },
    { key: 'clientDailyCalls', label: 'AI calls a day, the client', kind: 'number', defaultHint: '1000' },
    { key: 'questionsPerBriefing', label: 'Questions a briefing (0 off)', kind: 'number', defaultHint: '6' },
    { key: 'questionChars', label: 'Question length, most', kind: 'number', defaultHint: '300' },
    { key: 'emailAllowed', label: 'Email allowed', kind: 'boolean', defaultHint: 'on' },
    { key: 'briefingWords', label: 'Briefing words, most', kind: 'number', defaultHint: '180' },
    { key: 'answerWords', label: 'Answer words, most', kind: 'number', defaultHint: '80' },
    { key: 'facilitiesInFull', label: 'Facilities told in full', kind: 'number', defaultHint: '40' },
    { key: 'facilitiesListed', label: 'Facilities listed', kind: 'number', defaultHint: '400' },
    { key: 'defaultWindowDays', label: 'Window days, no sign-in', kind: 'number', defaultHint: '7' },
    { key: 'maxWindowDays', label: 'Window days, most', kind: 'number', defaultHint: '30' },
    { key: 'ttlDays', label: 'Kept for days', kind: 'number', defaultHint: '30' },
  ],
  helpTopics: BRIEFINGS_HELP_TOPICS,
}
